/* eslint-disable no-undef */
import React from "react";
import { Link } from "react-router-dom";
import doctorSvg from '../../../../public/doctor-circle.svg';
import noimageSvg from '../../../../public/noimage.svg';
import uploadicoSvg from '../../../../public/uploadfileico.svg';
import drequipSvg from '../../../../public/stethoscope.svg';
import { showLoading } from 'react-global-loading';
import UserService from '../../../../services/UserService';
import Modal from 'react-modal';
import CreateAssociationPractitionerUser from '../../superadmin/users/AssociationPractitioner/CreateUser.js';
export const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';
class PractitionersList extends React.Component {
  constructor(props) {
    super(props);
    const url = new URL(window.location);
    showLoading(true);
    this.state = {
      filteredList: [], approved: [], pending: [], practitioner: [], type: '', showUserViewModal: false,
      uname: url.searchParams.get('uname') || '', location: url.searchParams.get('location'),
    };
  }

  componentDidMount = () => {
    this.filterUser();
  };

  getAllPractitioners = (query) => {
    UserService.getUsersList(query)
      .then((result) => {
        if (!result) return;

        this.setState({
          practitioner: result
        });
        showLoading(false);
      }).catch((err) => {
        console.error(err);
      });
  };
  filterUser = () => {

    const url = new URL(window.location);
    { this.state.uname ? url.searchParams.set('uname', this.state.uname) : url.searchParams.delete('uname') }
    { this.state.location ? url.searchParams.set('location', this.state.location) : url.searchParams.delete('location') }


    let query = { role: "Practitioners" };
    this.state.uname && (query.uname = this.state.uname);
    this.state.location && (query.by = this.state.location);

    this.getAllPractitioners(query);
    window.history.pushState(null, '', url.toString());

  }
  render() {
    const { practitioner, showUserViewModal, uname, location } = this.state;

    return (
      <div className="container pt-2">
        <Modal
          isOpen={showUserViewModal}
          shouldCloseOnOverlayClick={true}
          ariaHideApp={false}
        >
          <CreateAssociationPractitionerUser dismissModal={(e) => (this.setState({ showUserViewModal: !this.state.showUserViewModal }), this.getAllPractitioners({ role: "Practitioners" }))} {...this.state} />

        </Modal>
        <div className="row bg-light p-3 mt-5 mb-3 rounded rounded-2 m-ver-col">
          <div className="col-md-10 head-title t0">
            <h4 className="t0">All Registered Practitioners, <span className="linear-title t0">{userData.blog_id?.blogname}</span></h4>
          </div>
          <div className="col-md-2 m-btn">
            <Link to="/add-my-practitioner-data" className="card-link rounded rounded-2 w-100 btntxdsh lightbtn t2">
              <i className="fa fa-plus-circle" aria-hidden="true"></i> Add New
            </Link>
          </div>
          <hr className="mt-4"></hr>
          <div className="col-12 mt-3">
            <div className="row contrast-ration-sol">
              <span className="text-dark d-block mb-2 t3">
                <i className="fa fa-filter" aria-hidden="true" /> Filter Practitioners
              </span>
              <div className="col-4 m-filter-col">
                <div className="form-group mb-4 position-relative has-search">
                  <span className="fa fa-search form-search"></span>
                  <input type="text" className="form-control adminsearchbox" aria-labelledby="username" onChange={(e) => this.setState({ uname: e.target.value })} value={uname} onKeyDown={e =>
                    e.key === "Enter" && this.filterUser()} placeholder="Search by user name" />
                </div>
              </div>
              <div className="col-4 m-filter-col">
                <div className="form-group mb-4 position-relative">
                  <label htmlFor="productname" id="location" className="bldlbl hdlb">enter location or pin code</label>
                  <input type="text" className="form-control adminlocationbox" aria-labelledby="location" placeholder="Enter location or Pin/ZIP code" onChange={(e) => this.setState({ location: e.target.value })} value={location} onKeyDown={e =>
                    e.key === "Enter" && this.filterUser()} />
                </div>
                <div className="form-group position-relative user-search-location-block">
                  <div className="searchbtn"> <button type="button" className="btn theme-btn-fill btndbg border-0 rounded-0 p-2" onClick={() => this.filterUser()}>Search</button></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row bg-light p-2 mt-5 mb-3 rounded rounded-2 m-ver-col mtless">
          <div className="col-12">

            <div className="tab-content" id="myTabContent">
              <div className="tab-pane fade show active" id="all-registered-pane" role="tabpanel" aria-labelledby="all-registered-pane" >
                <div className="row mt-4 contrast-ration-sol">
                  {practitioner.map((item, index) => <div key={index} className="col-md-6 mb-3 m-ccard">
                    <div className="card p-3 clinic-card">
                      <div className="row">
                        <div className="col-1 clinccrd-img">
                          <img src={item.data.user_image} className="mt-3" alt="centers and services" />
                        </div>
                        <div className="col-11">
                          <div className="card-body">
                            <h5 className="card-title fs-5 fw-bold t1"> {item.data.user_nicename}
                              <span className=" float-end fw-normal p-3 px-4 rounded rounded-5 countproduct t2">{item.data.user_products} Products</span></h5>
                            <p className="card-text">
                              {/* <small className="text-muted t4"><i className="fa fa-map-marker" aria-hidden="true" /> {item.data.user_country[0]?.blogname} </small> */}
                            </p>
                            {/* <p className="card-text t2"><b>Services</b> - {item.data.user_domains.map((item, index) => item)}</p> */}
                            <div className="domain-chips">{item?.data?.user_domains?.map((item1, index) => <span className="muted d-block mt-1 doccell t4">{item1}   </span>)}</div>
                            <p className="card-text t3 text-end">
                              {/* <span className="praccarlnk fw-bold" onClick={(e) => this.setState({ type: 'edit', userData: item, showUserViewModal: !this.state.showUserViewModal })}>Edit Details</span>| */}
                              <span onClick={(e) => this.setState({ type: 'view', userData: item, showUserViewModal: !this.state.showUserViewModal })} className="praccarlnk fw-bold">View Details</span> | <Link to={{
                                pathname:
                                  "/practitioners-products-list/" +
                                  item.data.ID
                              }} className="praccarlnk fw-bold">View Products</Link></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>)}
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    );
  }
}
export default PractitionersList;